import { Component, computed, inject, input } from '@angular/core';

import { GeofenceService } from '@core/services/geofence';

@Component({
  selector: 'app-geofence-details-header',
  templateUrl: './geofence-details-header.html',
  styleUrl: './geofence-details-header.scss'
})
export class GeofenceDetailsHeader {
  readonly geofenceAPIs = inject(GeofenceService);

  readonly id = input.required<string>();

  readonly geofence = computed(() => this.geofenceAPIs.geofences().find((g) => g.geofenceId === this.id()) ?? null);
}
